export default __webpack_public_path__ + "static/media/workspace.6e70dca0.svg";